import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, Progress, TitleHeader, useSnackbarHandler } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetExamLevelsAndResourceTypes } from '../../../api-refactored/onlineTutorials/useGetExamLevelsAndResourceTypes';
import { useGetCheckAuthorityExist } from '../../../api-refactored/user/useGetCheckAuthorityExist';
import ResourceListSearchAndFilter from '../../../modules/usefulInformation/components/ResourceListSearchAndFilter';
import { useOnlineTutorialsContext } from '../../../routes/AdminRoute';

const UsefulInformationListing = () => {
  const { t } = useTranslation();
  const {
    isAddSuccess,
    isEditSuccess,
    setIsAddSuccess,
    setIsEditSuccess,
  } = useOnlineTutorialsContext();

  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const { snackbarHandler } = useSnackbarHandler();

  useGetCheckAuthorityExist({
    authorityName: AUTHORITY_NAMES.CP_ADMIN_USEFUL_INFORMATION_VIEW,
  });

  useEffect(() => {
    if (isAddSuccess) {
      snackbarHandler?.setGlobalSnackbar({
        targetSeverity: 'success',
        targetData: t('usefulInformation->>ResourceForm.ResourceSuccessfullyAdded'),
        targetAnchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      });
      setIsAddSuccess(false);
    }
  }, [isAddSuccess, setIsAddSuccess, snackbarHandler, t]);

  useEffect(() => {
    if (isEditSuccess) {
      snackbarHandler?.setGlobalSnackbar({
        targetSeverity: 'success',
        targetData: t('usefulInformation->>ResourceForm.ResourceSuccessfullyUpdated'),
        targetAnchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      });
      setIsEditSuccess(false);
    }
  }, [isEditSuccess, setIsEditSuccess, snackbarHandler, t]);

  const { data } = useGetExamLevelsAndResourceTypes({
    onSuccess: () => {
      setIsSuccess(true);
    },
  });

  return (
    <>
      <TitleHeader title={t('usefulInformation->>Listing.UsefulInformation')} />
      <ContentTemplate type="full">
        {isSuccess ? (
          <ResourceListSearchAndFilter filterData={data} />
        ) : (
          <Progress color="secondary" />
        )}
      </ContentTemplate>
    </>
  );
};

export default UsefulInformationListing;
